import { render } from "./FooterSocialNetworks.vue?vue&type=template&id=2020def6"
import script from "./FooterSocialNetworks.vue?vue&type=script&lang=js"
export * from "./FooterSocialNetworks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__